import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Default hero images - can be overridden by API
const defaultHeroImages = {
  '/': 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8dGVjaCUyMG9mZmljZXxlbnwwfHwwfHx8MA%3D%3D',
  '/products': 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0',
  '/about': 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0',
  '/partnerships': 'https://images.unsplash.com/photo-1552664730-d307ca884978?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0',
  '/contact': 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0',
};

function getHeroImage(pathname) {
  return defaultHeroImages[pathname] || defaultHeroImages['/'];
}

export function HeroImage({ children, title, subtitle }) {
  const location = useLocation();
  const pathname = location.pathname;
  const [heroImageUrl, setHeroImageUrl] = useState(() => getHeroImage(pathname));

  useEffect(() => {
    // Try to fetch from API, fallback to default
    const fetchHeroImage = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
        const response = await fetch(`${apiUrl}/api/hero-images/${pathname}`);
        if (response.ok) {
          const data = await response.json();
          setHeroImageUrl(data.image_url);
        }
      } catch (error) {
        // Fallback to default
        setHeroImageUrl(getHeroImage(pathname));
      }
    };

    fetchHeroImage();
  }, [pathname]);

  return (
    <section className="hero-section">
      <div className="hero-background">
        <img
          src={heroImageUrl}
          alt="Hero background"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container mx-auto px-5 md:px-10 relative z-10">
        <div className="hero-content max-w-4xl mx-auto text-center">
          {title && <h1 className="hero-title mb-6">{title}</h1>}
          {subtitle && <p className="body-large max-w-3xl mx-auto mb-8 !text-[#FFFFFF]">{subtitle}</p>}
          {children}
        </div>
      </div>
    </section>
  );
}
